import * as React from 'react';
import styled from 'styled-components';

// ############################ Imported from Old UI ###########################

// ############################ Styles ###########################
// tslint:disable:variable-name

const SLegalText = styled.p<{ padding?: string }>(
  ({ theme, padding }) => `
  display:block;
  font-size: ${theme.font.size.smallMedium};
  font-weight: ${theme.font.weight.light};
  color: ${theme.colors.grayDark};
  padding: ${padding};
`
);

// tslint:enable:variable-name
// ############################ End Styles ###########################

interface ILegalTextProps {
  dataAt?: string;
  'data-testid'?: string;
  className?: string;
  padding?: string;
  tabIndexProp?: number;
  id?: string;
}

// tslint:disable-next-line:variable-name
const LegalText: React.FC<ILegalTextProps> = (props) => (
  <SLegalText
    id={props.id || ''}
    tabIndex={props.tabIndexProp || 0}
    padding={props.padding}
    className={props.className}
    data-at={props.dataAt}
    data-testid={props['data-testid']}
  >
    {props.children}
  </SLegalText>
);

export default LegalText;
